export default "__VITE_ASSET__CERKg76s__"